// shared-designer/src/lib/toast.tsx · v12.10.3 (BDR-016) · 2026-10-03 · VoiceSpectrum AI
// The shared designer's toast: forwards to the HOST's toast (configureDesignerHost). A host without one gets a no-op.
import { designerHost, type DesignerToastHandle, type DesignerToastType } from '../host';

export type ToastType = DesignerToastType;

export function toast(type: ToastType, title: string, message?: string, opts?: { durationMs?: number }): DesignerToastHandle {
  const t = designerHost().toast;
  if (t) return t(type, title, message, opts);
  const handle: DesignerToastHandle = { id: 0, close: () => {}, resolve: () => handle };
  return handle;
}
